const getCollectionSlug = (item: any): string => {
	if (item?.parent) {
		return getCollectionSlug(item.parent);
	}
	return item.slug;
};

export default getCollectionSlug;
